let playButton = $(".video-popup-button"),
	videoContainer = $(".video-container.external"),
	videoModal = $(".modal-video"),
	videoModalWrapper = $(".modal-wrapper"),
	videoModalPlayer = $(".modal-wrapper video"),
	closeModal = $(".modal-close"),
	videoReviewMain = $(".reviews-video__main_img"),
	videoReviewThumb = $(".reviews-video__thumbnail");

/* eslint-disable */
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let playerInfoList = [],
	playerStatus = [],
	players = [],
	youtubeIframeAPIInit = false;

$.each(videoContainer, function() {
	let videoInfo = {};

	videoInfo.id = $(this)
		.children()
		.attr("id");
	videoInfo.videoId = $(this).attr("data-video-id");
	playerInfoList.push(videoInfo);

	let ob = {}
	ob[videoInfo.id +'-ready'] = false;
	playerStatus.push( ob );
});

window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
	if(!youtubeIframeAPIInit) {
		youtubeIframeAPIInit = true;
	}

	if (typeof playerInfoList === "undefined") return;

	if( typeof YT === 'undefined' ) {
		setTimeout(function () {
			if( typeof YT === 'undefined' ) {
				onYouTubeIframeAPIReady();
			} else {
				return;
			}
		}, 2000);
		return;
	} else {
		for (var i = 0; i < playerInfoList.length; i++) {
			players[playerInfoList[i]["id"]] = createPlayer(playerInfoList[i]);
		}
	}

};
function createPlayer(playerInfo) {
	return new YT.Player(playerInfo.id, {
		videoId: playerInfo.videoId,
		height: "100%",
		width: "100%",
		playerVars: {
			'playsinline': 1,
			'origin': location.hostname
		},
		events: {
			'onReady'() {
				playerStatus[playerInfo.id+'-ready'] = true;
			}
		},
	});
}

videoReviewThumb.on("click", function() {
	if (!$(this).hasClass("border")) {
		let videoIndex = $(this).attr("data-video-index");
		let videoUrl = $(this).attr("data-video-url");
		let videoPoster = $(this).attr("data-video-poster");
		let videoContainerId = $(this).attr("data-video-container-id");
		videoReviewMain = $(".reviews-video__main_img:visible");
		let videoReviewMainSecond = $(".reviews-video__main_img").not(":visible");
		let videoReviewButton = $(".reviews-video__main_play-btn");
		videoReviewMainSecond.css("background-image", "url(" + videoPoster + ")");
		videoReviewMainSecond.attr("data-video-poster", videoPoster);
		videoReviewMainSecond.attr("data-video-url", videoUrl);
		videoReviewMainSecond.attr("data-video-index", videoIndex);
		videoReviewButton.attr("data-video-container-id", videoContainerId);
		videoReviewMainSecond.fadeIn();
		videoReviewMain.fadeOut();
		videoReviewThumb.removeClass("border");
		$(this).addClass("border");
	}
});

playButton.on("click", function() {
	$("body").addClass("fix");
	let iframeID = $(this).attr("data-video-container-id");
	$(".modal[data-video-container-id=" + iframeID + "]").fadeIn();
	$(".video-container[data-video-container-id=" + iframeID + "]").show();
	if ($(".video-container:visible").hasClass("external")) {
		setTimeout(() => {
			playerAPI();
		}, 400);

		function playerAPI() {
			if(playerStatus[iframeID+'-ready']) {
				players[iframeID].playVideo();
				return;
			} else {
				setTimeout(() => {
					playerAPI();
				}, 400);
			}
		}
	} else {
		$(".video-container:visible video")
			.get(0)
			.play();
	}
});

closeModal.on("click", function() {
	let iframeID = $(this)
		.parent()
		.find(".video-container")
		.attr("data-video-container-id");
	$("body").removeClass("fix");
	$(".modal[data-video-container-id=" + iframeID + "]").fadeOut();
	if (
		$(".modal[data-video-container-id=" + iframeID + "]").hasClass(
			"external-video"
		)
	) {
		if(playerStatus[iframeID+'-ready']) {
			players[iframeID].stopVideo();
			return;
		} else {
			$('#'+iframeID).attr('src', $('#'+iframeID).attr('src'));
		}
	} else {
		videoModalPlayer.get(0).pause();
		videoModalPlayer.get(0).currentTime = 0;
	}
	setTimeout(() => {
		$(".video-container").hide();
	}, 600);
});

videoModal.on("click", function(e) {
	if ($(e.target).is(this) || $(e.target).is(videoModalWrapper)) {
		let iframeID = $(this)
			.find(".video-container")
			.attr("data-video-container-id");

		$("body").removeClass("fix");
		$(".modal[data-video-container-id=" + iframeID + "]").fadeOut();
		if (
			$(".modal[data-video-container-id=" + iframeID + "]").hasClass(
				"external-video"
			)
		) {
			if(playerStatus[iframeID+'-ready']) {
				players[iframeID].stopVideo();
				return;
			} else {
				$('#'+iframeID).attr('src', $('#'+iframeID).attr('src'));
			}
		} else {
			videoModalPlayer.get(0).pause();
			videoModalPlayer.get(0).currentTime = 0;
		}
		setTimeout(() => {
			$(".video-container").hide();
		}, 600);
	}
});

$(document).ready(function () {
	if(!youtubeIframeAPIInit) {
		onYouTubeIframeAPIReady();
	}
});


// WEBPACK FOOTER //
// ./scripts/modules/video-popups.js